import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Route } from "react-router-dom";
import "./index.css";
import { loadTemplates } from "./state/schema/action";

import { createStore } from "./state";
import Main from "./components/Main";

import { loadTheme, registerIcons } from "@uifabric/styling";
import { initializeIcons } from "@uifabric/icons";
import { loadMedia } from "./state/media/action";
import { loadLanguages } from "./state/translation/action";
//loadTheme({});
import customIcons from "~/components/icons/icons.tsx";
import { loadGroups } from "./state/group/action";
import { loadTabs } from "./state/tab/action";
import { loadTags } from "./state/tag/action";
import { loadCollections } from "./state/collection/action";
loadTheme({
    palette: {
      themePrimary: "#2B7092",
      themeLighterAlt: "#eff6fc",
      themeLighter: "#deecf9",
      themeLight: "#c7e0f4",
      themeTertiary: "#71afe5",
      themeSecondary: "#2b88d8",
      themeDarkAlt: "#2B7092",
      themeDark: "#005a9e",
      themeDarker: "#004578",
      neutralLighterAlt: "#f8f8f8",
      neutralLighter: "#E0EBEF",
      neutralLight: "#eaeaea",
      neutralQuaternaryAlt: "#dadada",
      neutralQuaternary: "#d0d0d0",
      neutralTertiaryAlt: "#c8c8c8",
      neutralTertiary: "#c2c2c2",
      neutralSecondary: "#858585",
      neutralPrimaryAlt: "#4b4b4b",
      neutralPrimary: "#333333",
      neutralDark: "#272727",
      black: "#1d1d1d",
      white: "#ffffff",
    }
  });

registerIcons(customIcons);

initializeIcons();

const store = createStore();

store.dispatch<any>(loadTemplates());
store.dispatch<any>(loadMedia());
store.dispatch<any>(loadLanguages());
store.dispatch<any>(loadGroups());
store.dispatch<any>(loadTabs());
store.dispatch<any>(loadTags());
store.dispatch<any>(loadCollections());

const rootApp = (
    <Provider store={store}>
        <BrowserRouter>
            <Route path="/" render = {(props) => <Main {...props}/>} />
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(rootApp, document.getElementById("root") as HTMLElement);




// WEBPACK FOOTER //
// ./src/index.tsx